import { all, call, put, select, takeLatest } from "redux-saga/effects";
import { http } from "../../common/lib";
import config from "../../config";
import { actionCreators, actionTypes } from "./actions";
import { logToSentry } from "../../config/Sentry";

function* getRequest(action) {
    const { token, uploadId } = action.payload;
    const url = `${config.api.paths.validationErrors}?upload_id=${uploadId}`;
    try {
        let res = null;
        if (token) {
            const Authorization = `Bearer ${token}`;
            res = yield call(http.anonymous.get, url, { Authorization });
        } else {
            const { id } = yield select(
                (state) => state.userOrganisations.item
            );
            res = yield call(http.authorized.get, `${url}&organisation=${id}`);
        }
        yield put(actionCreators.getSuccess(res.data));
    } catch (error) {
        logToSentry("On validation errors get:", { error });
        yield put(actionCreators.getFailure(error));
    }
}

export default function* () {
    yield all([
        takeLatest(actionTypes.VALIDATION_ERRORS_GET_REQUEST, getRequest)
    ]);
}
